import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Send } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function BottomCTA() {
  const { lang } = useLang();

  const content = lang === 'ru' ? {
    title: 'Обсудим запуск KidsMafia в вашем городе',
    subtitle: 'Покажем модель, условия входа и возможные форматы запуска.',
    cta_primary: 'Позвонить',
    cta_secondary: 'Написать в Telegram',
  } : {
    title: 'Discutamos el lanzamiento de KidsMafia en su ciudad',
    subtitle: 'Mostraremos el modelo, condiciones de entrada y posibles formatos de lanzamiento.',
    cta_primary: 'Llamar',
    cta_secondary: 'Escribir por Telegram',
  };

  return (
    <section className="relative py-20 md:py-28 px-6 overflow-hidden">
      {/* Background gradient */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(10,11,15,0) 0%, rgba(212,175,55,0.08) 50%, rgba(10,11,15,0) 100%)',
        }}
      />

      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="glass-gold rounded-3xl p-10 md:p-12 text-center"
          style={{
            boxShadow: '0 20px 60px rgba(212,175,55,0.25), inset 0 1px 0 rgba(255,215,0,0.2)',
          }}
        >
          {/* Title */}
          <h2 className="text-3xl md:text-5xl font-black font-heading gold-text mb-6 leading-tight">
            {content.title}
          </h2>

          {/* Subtitle */}
          <p className="text-white text-lg md:text-xl mb-10 font-medium">
            {content.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.a
              href="tel:+34624586917"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="btn-call flex items-center gap-3 px-8 py-4 rounded-full text-base font-bold w-full sm:w-auto justify-center min-w-[200px] shadow-2xl"
            >
              <Phone size={20} />
              {content.cta_primary}
            </motion.a>
            <motion.a
              href="https://t.me/SerjValencia"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.98 }}
              className="btn-telegram flex items-center gap-3 px-8 py-4 rounded-full text-base font-bold w-full sm:w-auto justify-center min-w-[200px] shadow-2xl"
            >
              <Send size={20} />
              {content.cta_secondary}
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
